export default __webpack_public_path__ + "img/time.77a30d77.svg";